import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { Icons, InfoPopup } from '../../../../../components';
import css from './TalentPlusServices.module.css';

const CustomOptions = ({ fields, talentPlusOptions, viewport }) => {
  const isMobileLayout = viewport.width && viewport.width > 0 && viewport.width < 768;
  const handleAddCustomOption = () => {
    fields.push({
      service: '',
      type: '',
      price: '',
      selected: true,
    });
  };
  return (
    <div className={css.talentPlusServices}>
      <div className={css.headingContainer}>
        <h2>
          <FormattedMessage id="TalentPlusServices.CustomOptions.heading" />
        </h2>
        <InfoPopup
          triggerOn="hover"
          info="Show your unique skills by offering your own custom service."
        />
      </div>
      <>
        {fields.map((name, index) => {
          // Check if the current item is a custom option by ensuring the `service` field is editable.
          const isCustomOption =
            fields.value[index]?.selected &&
            !talentPlusOptions.some(option => option.service === fields.value[index]?.service);

          if (!isCustomOption) return null;

          return (
            <div key={index} className={css.customItemRow}>
              {/* Service Name Field */}
              <div className={css.formFld}>
                <Field
                  name={`${name}.service`}
                  component="input"
                  placeholder="Enter service name"
                  className={css.input}
                />
              </div>
              {/* Type Field */}
              <div className={css.formFld}>
                <Field
                  name={`${name}.type`}
                  component="input"
                  placeholder="Enter type"
                  className={css.input}
                />
              </div>
              {/* Price Field */}
              <div className={css.customItemField}>
                <div className={css.customFldSec}>
                  <span className={css.currency}>$</span>
                  <Field
                    name={`${name}.price`}
                    component="input"
                    placeholder="Enter hourly price"
                    type="number"
                    className={css.input}
                  />
                  <span className={css.price}>.00</span>
                </div>
              </div>
              {/* Remove Button */}
              <button
                type="button"
                className={css.removeBtn}
                onClick={e => {
                  e.stopPropagation(); // Prevent event propagation
                  fields.remove(index);
                }}
              >
                {isMobileLayout ? (
                  <>
                    <Icons name="bin" /> Delete
                  </>
                ) : (
                  <Icons name="bin" />
                )}
              </button>
            </div>
          );
        })}
        {/* Add Custom Option Button */}
        <button type="button" className={css.addCustomBtn} onClick={handleAddCustomOption}>
          <FormattedMessage id="TalentPlusServices.CustomOptions.addCustomOption" />
        </button>
      </>
    </div>
  );
};

export default CustomOptions;
